<section class="pt-8 @container">
  <div class="flex items-center gap-2.5 pb-3">
    <h2 class="text-base font-bold tracking-[-0.01em] text-foreground">Handlungsbedarf</h2>
    @if (!isInitialLoading() && totalFailed() > 0) {
      <span hlmBadge class="bg-destructive/10 text-destructive border-destructive/20">{{ totalFailed() }}</span>
      @if (currentOrgStore.can('analysis', 'startAnalysis')) {
      <button
        type="button"
        (click)="retryAll()"
        [disabled]="anyBusy()"
        class="ml-auto text-dense text-muted-foreground transition-colors hover:text-foreground disabled:opacity-50"
      >
        Alle wiederholen
      </button>
      }
    }
  </div>

  <div class="border-t border-border">
    @if (isInitialLoading()) {
      @for (i of [1, 2, 3]; track i) {
        <div class="h-14 border-b border-border/60 flex items-center">
          <div class="h-3 w-2/5 rounded bg-muted animate-pulse"></div>
        </div>
      }
    } @else if (totalFailed() === 0) {
      <div class="flex items-center gap-3 py-4">
        <ng-icon name="lucideCircleCheck" class="w-4 h-4 text-success shrink-0" />
        <span class="text-sm text-muted-foreground">Alles läuft rund. Keine fehlgeschlagenen Analysen.</span>
      </div>
    } @else {
      <!-- Caps at ~6 rows and scrolls; the next page loads as it nears the end. -->
      <div class="max-h-[336px] overflow-y-auto" (scroll)="onScroll($event)">
        @for (item of visibleItems(); track item.analysisId) {
          <!-- The whole row is the hit area, so the address highlights wherever
               in the row the pointer is. -->
          <div
            class="action-row group grid items-center gap-x-4 gap-y-1.5 py-3 pr-1 border-b border-border/60 cursor-pointer transition-colors hover:bg-muted/50"
          >
            <span
              class="ml-1 w-1.5 h-1.5 rounded-full"
              [class]="isRetrying(item.analysisId) ? 'bg-primary animate-pulse' : 'bg-destructive'"
            ></span>

            <app-analysis-reference [analysisId]="item.analysisId" [address]="item.address" [organizationSlug]="currentOrgStore.organizationSlug()!" />

            <span class="min-w-0 truncate text-dense text-muted-foreground" [title]="errorDetail(item)">
              {{ errorLabel(item) }}
            </span>

            <span class="whitespace-nowrap text-dense text-muted-foreground">{{ executionLabel(item) }}</span>

            <span class="action-time font-mono text-2xs text-muted-foreground whitespace-nowrap">
              {{ changedAt(item) }}
            </span>

            <div class="flex items-center gap-0.5">
              @if (currentOrgStore.can('analysis', 'startAnalysis')) {
              <button
                type="button"
                aria-label="Wiederholen"
                title="Wiederholen"
                [disabled]="isRetrying(item.analysisId)"
                (click)="retry(item); $event.stopPropagation()"
                class="size-7 inline-flex items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-primary disabled:opacity-50"
              >
                <ng-icon
                  name="lucideRotateCcw"
                  class="w-3.5 h-3.5 [animation-direction:reverse]"
                  [class.animate-spin]="isBusy(item.analysisId)"
                />
              </button>
              }
              <button
                type="button"
                aria-label="Öffnen"
                title="Öffnen"
                (click)="open(item); $event.stopPropagation()"
                class="size-7 inline-flex items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
              >
                <ng-icon name="lucideExternalLink" class="w-3.5 h-3.5" />
              </button>
              <button
                type="button"
                aria-label="Ignorieren"
                title="Ignorieren"
                (click)="dismiss(item.analysisId); $event.stopPropagation()"
                class="size-7 inline-flex items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
              >
                <ng-icon name="lucideX" class="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        }

        @if (isLoadingMore()) {
          <div class="h-14 flex items-center font-mono text-2xs text-muted-foreground">Lädt…</div>
        }
      </div>
    }
  </div>
</section>
